<template>
  <div class="activitylist">
    <template v-if="list.length > 0">
      <div class="list_item" v-for="(item, i) in list" :key="i">
		  <div class="main_title">
		  	<div class="img"></div>
		  	<div class="title">{{item.name}}</div>
		  </div>
		  <div class="line"></div>
		  <div v-if="item.begin_time" class="info-content-left">
		  	<span>开始时间：</span>
			<span>{{item.begin_time}}</span>
		  </div>
		  <div v-if="item.end_time" class="info-content-left">
		  	<span>结束时间：</span>
			<span>{{item.end_time}}</span>
		  </div>
		  <div class="info-content-left">
		  	<span class="more-title">活动介绍：</span>
		  	<span class="more-content">{{item.describe}}</span>
		  </div>
      </div>
    </template>
    <van-empty
      v-else
      class="custom-image"
      image="https://img01.yzcdn.cn/vant/custom-empty-image.png"
      description="暂无活动预告哦~"
    />
  </div>
</template>

<script>
// import { getNextActivityList } from "@/api/draw.js";
import { getNextActivityList } from "@/api/draw.js"
export default {
  data() {
    return {
      list: [],
      page: 0,
    };
  },
  created() {
   this.page = 0;
    this.getList();
  },
  methods: {
    async getList() {
      const data = await getNextActivityList({
        page: this.page,
        // userId: this.userInfo.id,
      });
      console.log(data);
      if (data.code == 200) {
        this.list = data.data;
      }
    },
  },
};
</script>
<style lang="scss" scoped>
/deep/ .custom-image .van-empty__image {
  width: 90px;
  height: 90px;
}
div {
  box-sizing: border-box;
}
img {
  width: 100%;
  height: 100%;
}
.activitylist {
  width: 100%;
  height: 100%;
  padding: 10px 13px;
  background-color: #f6f6f6;
  .list_item {
    margin-top: 10px;
    width: 100%;
    border-radius: 8px;
    // height: 111px;
    background-color: #fcfcfc;
    // display: flex;
    // align-items: center;
    justify-content: space-between;
    // padding: 10px;
	.main_title{
		display: flex;
		padding: 17px 0px;
		.img {
		  width: 2px;
		  height: 16px;
		  background-color: #017FD9;
		  // border-radius: 4px;
		  // overflow: hidden;
		}
		.title{
			margin-left: 16px;
			width: 320px;
			text-align: left;
			font-size: 16px;
			font-family: PingFang SC;
			font-weight: 500;
			color: #333333;
		}
	}
	.line{
		background-color: #EEEEEE;
		width: 100%;
		height: 0.5px;
	}
   
	// .beginDate{
	// 	margin-left: 16px;
	// 	width: 100%;
	// 	text-align: left;
	// 	font-size: 14px;
	// 	font-family: PingFang SC;
	// 	font-weight: 500;
	// 	color: #999999;
	// }
	//  每一行的信息
	.info-content-left {
	  position: relative;
	  margin: 10px 0;
	  text-align: left;
	  font-size: 14px;
	  font-family: PingFang SC;
	  font-weight: 500;
	  span {
	    &:first-child {
	      display: inline-block;
	      width: 85px;
	      padding: 5px;
	      box-sizing: border-box;
	      color: #999999;
	    }
	    &:last-child {
	      display: inline-block;
	      width: 203px;
	      color: #333333;
	      // margin-left: 5px;
	    }
	  }
	  // 问题描述
	  .more-title {
	    display: inline-block;
	    width: 85px;
	    padding: 5px;
	    position: absolute;
	  }
	  .more-content {
		padding: 5px 0px;
	    margin-left: 85px !important;
	  }
 
    }
  }
}
</style>
<style>
.van-empty {
  position: fixed;
  top: 50%;
  left: 50%;
  transform: translate3d(-50%, -50%, 0);
  transition: transform 0.3s;
}
.van-empty__description {
  width: 100%;
}
</style>
